import { call } from "redux-saga/effects";

let openDiagnosisModule = null;
export function* openDiagnosis({ handlingCode = 0, payload, notification = false }) {
  if (!openDiagnosisModule) {
    openDiagnosisModule = yield call(() => import('./open-diagnosis'));
  }
  //llamada a modulo
  yield call(openDiagnosisModule.openDiagnosis, { handlingCode, payload, notification })
}

let getReasonModule = null;
export function* getReason({ handlingCode = 0, payload }) {
  if(!getReasonModule){
    getReasonModule = yield call(() => import('./get-reason'))
  }
  yield call(getReasonModule.getReason, { handlingCode, payload })
  // llamada a modulo
}
let sendInfoToDiagnosisModule = null;
export function* sendInfoToDiagnosis({ handlingCode = 0, payload }) {
  if(!sendInfoToDiagnosisModule){
    sendInfoToDiagnosisModule = yield call(() => import('./send-info-to-diagnosis'))
  }
  yield call(sendInfoToDiagnosisModule.sendInfoToDiagnosis, { handlingCode, payload })
  //llamada modulo
}
let getDiagnosisStateModule = null;
export function* getDiagnosisState(data) {
  if(!getDiagnosisStateModule){
    getDiagnosisStateModule = yield call(() => import('./get-diagnosis-state'))
  }
  yield call(getDiagnosisStateModule.getDiagnosisState, data)
  //llamada modulo
}
let putContinueDiagnosisModule = null;
export function* putContinueDiagnosis({ handlingCode = 0, payload }) {
  if(!putContinueDiagnosisModule){
    putContinueDiagnosisModule = yield call(() => import('./put-continue-diagnosis'))
  }
  yield call(putContinueDiagnosisModule.putContinueDiagnosis, { handlingCode, payload })
  // llamada modulo
}

let putReiterateDiagnosisModule = null;
export function* putReiterateDiagnosis({ handlingCode = 0, payload }) {
  if(!putReiterateDiagnosisModule){
    putReiterateDiagnosisModule = yield call(() => import('./put-reiterate-diagnosis'))
  }
  yield call(putReiterateDiagnosisModule.putReiterateDiagnosis, { handlingCode, payload })
  // llamada modulo
}

let putValidateDiagnosisModule = null;
export function* putValidateDiagnosis({ handlingCode = 0, payload }) {
  if(!putValidateDiagnosisModule){
    putValidateDiagnosisModule = yield call(() => import('./put-validate-diagnosis'))
  }
  yield call(putValidateDiagnosisModule.putValidateDiagnosis, { handlingCode, payload })
  // llamada modulo
}

let putCancelDiagnosisModule = null;
export function* putCancelDiagnosis({ handlingCode = 0, payload }) {
  if(!putCancelDiagnosisModule){
    putCancelDiagnosisModule = yield call(() => import('./put-cancel-diagnosis'))
  }
  yield call(putCancelDiagnosisModule.putCancelDiagnosis, { handlingCode, payload })
  // llamada modulo
}

